import React, { useState } from "react";

export default function WeatherTemp(props) {
	const [unit, setUnit] = useState("celsius");

	function showFahrenheit(event) {
		event.preventDefault();
		setUnit("fahrenheit");
	}

	function showCelsius(event) {
		event.preventDefault();
		setUnit("celsius");
	}

	function fahrenheitConversion() {
		return (Math.round((props.celsius * 9 / 5) + 32));
	}

	if (unit === "celsius") {
		return (
    <div>
			<h4 className="degrees float-left">{props.celsius}</h4>
			<div className="float-left links">
				<a href="/" className="active">
					°C
				</a>
				<span>&nbsp;|&nbsp;</span>
				<a href="/" onClick={showFahrenheit}>°F</a>
			</div>
		</div>
    );
	} else {
		return (
    <div>
			<h4 className="degrees float-left">{fahrenheitConversion()}</h4>
			<div className="float-left links">
				<a href="/" onClick={showCelsius}>°C</a>
				<span>&nbsp;|&nbsp;</span>
				<a href="/" className="active">°F</a>
			</div>
		</div>
    );
	}
}